<button
    class="menu-item"
    mat-button
    (click)="onClick()"
    [routerLink]="link"
    [disabled]="disabled"
    routerLinkActive="active"
    #rla="routerLinkActive"
    [ngStyle.md]="{ padding: '0 1em' }"
    [ngStyle.sm]="{ padding: '0 1em' }"
    [ngStyle.xs]="{ padding: '0 1em' }"
    fxFlex.lt-md="1 0 100%"
>
    <ng-content></ng-content>
</button>
